module.exports = __webpack_public_path__ + "static/cstoreslider-16-min-5f097cae8a1af3c087398854ac5be036.jpg";